<script>
  export let params;
  export let currentRoute;
  import { navigateTo } from "svelte-router-spa";
  import Content from './PopupDenuncia.svelte';

  import { Modal, Button, Card } from 'svelte-chota';

  let modal_open = false;
  const modal_show = event => modal_open = true;
  const modal_hide = event => modal_open = false;

</script>

<section id="home">

  <div class="hero-wrap">
    <div class="hero-mask opacity-6 bg-dark" />
    <div
      class="hero-bg parallax"
      style="background-image:url('images/bg/home_1280.jpg'); opacity: 0.5;" />
    <div class="hero-content d-flex flex-column fullscreen">
      <div class="container my-auto">
        <div class="row py-5">
          <div class="col-sm-12 col-lg-4">
            <div
              class="featured-box style-4 bg-white px-4 shadow-sm border-bottom
              border-primary border-2 py-5 mt-4">
              <div
                class="featured-box-icon bg-primary text-white rounded-circle"
                style="cursor:pointer"
                on:click={() => navigateTo('denuncia')}
              >
                <i class="fas fa-gavel" />
              </div>
              <h3>Ingresar Denuncia Anónima</h3>
              <p class="mb-10">Ingrese una denuncia y haga seguimiento en forma confidencial.</p>

              <div style="position:absolute; bottom:0px;width: 100%; left:0px; margin-bottom:25px;">
                <a class="mb-0" href="/terms-conditions" target="_blank" style="">Ver términos y condiciones</a>
              </div>

            </div>
          </div>
          <div class="col-sm-12  col-lg-4">
            <div
              class="featured-box style-4 bg-white px-4 shadow-sm border-bottom
              border-primary border-2 py-5 mt-4">
              <div
                class="featured-box-icon bg-primary text-white rounded-circle"
                style="cursor:pointer"
                on:click={() => navigateTo('asistencia')}
              >
                <i class="fas fa-plus" />
              </div>
              <h3>Ingresar Asistencia Legal Gratuita</h3>
              <p class="mb-0">
                Ingrese una consulta y reciba asesoría de parte de nuestros Abogados.
              </p>

              <div style="position:absolute; bottom:0px;width: 100%; left:0px; margin-bottom:25px;">
                <a class="mb-0" href="/terms-conditions" target="_blank" style="">Ver términos y condiciones</a>
              </div>

            </div>
          </div>
          <div class="col-sm-12 col-lg-4">
            <div
              class="featured-box style-4 bg-white px-4 shadow-sm border-bottom
              border-primary border-2 py-5 mt-4">
              <div
                class="featured-box-icon bg-primary text-white rounded-circle"
                style="cursor:pointer"
                on:click={() => navigateTo('estado-denuncia')}
              >
                <i class="fas fa-search" />
              </div>
              <h3>Consultar Estado de Denuncia Anónima o Asistencia Legal Gratuita</h3>
              <p class="mb-0">
                Verifica el estado de tu caso ingresando el Número de denuncia/asistencia legal y la
                contraseña entregada al momento de crearla.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>